/**
 * Centralized default values for form fields
 * Ensures consistency across the application
 */

/**
 * Phone field defaults
 * Note: react-phone-number-input uses lowercase ISO 3166-1 alpha-2 codes
 */
export const PHONE_FIELD_DEFAULTS = {
  defaultCountry: 'KW' as const,
  preferredCountries: ['KW'] as const,
  onlyCountries: ['KW'] as const,
}

/**
 * Country field defaults
 * Note: Most country libraries use uppercase ISO 3166-1 alpha-2 codes
 */
export const COUNTRY_FIELD_DEFAULTS = {
  preferredCountries: ['KW'] as const,
  onlyCountries: ['KW'] as const,
}
